import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { dialingOptions } from "../../InterfacesAndComponents/stringUtils";

const IVRInteractiveVoiceResponseOverview = ({ data }) => {
  const {
    ivr_would_you_like_ivr_services,
    ivr_language,
    ivr_language_other,
    ivr_dialing_you_like_to_use_with_ivr,
    ivr_dialing_you_like_to_use_with_ivr_other,
    ivr_would_you_like_i2c_to_provide_toll_free_number_did,
    ivr_would_you_like_to_resporg_your_toll_free_number_to_i2c,
  } = data["3_5"];

  const languageValue = [
    ...(ivr_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(ivr_language?.includes("other") && ivr_language_other?.length
      ? [`Other (${toTitleCase(ivr_language_other)})`]
      : []),
  ].join(", ");

  const dialingValue = (() => {
    // Handle if it's an array
    if (Array.isArray(ivr_dialing_you_like_to_use_with_ivr)) {
      return ivr_dialing_you_like_to_use_with_ivr
        .map((val) => {
          if (val === "other") {
            return `Other (${toTitleCase(ivr_dialing_you_like_to_use_with_ivr_other)})`;
          }
          return dialingOptions.find((option) => option.value === val)?.label || val;
        })
        .join(", ");
    }
    
    // Handle if it's a single value
    if (ivr_dialing_you_like_to_use_with_ivr?.length) {
      if (ivr_dialing_you_like_to_use_with_ivr === "other") {
        return `Other (${toTitleCase(ivr_dialing_you_like_to_use_with_ivr_other)})`;
      }
      return dialingOptions.find(
        (option) => option.value === ivr_dialing_you_like_to_use_with_ivr,
      )?.label || ivr_dialing_you_like_to_use_with_ivr;
    }
    
    return "-";
  })();

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="IVR - Interactive Voice Response (C-Touch)" />
        </div>
        <ReviewAttribute
          label="Would you like i2c to provide IVR Services?"
          value={
            ivr_would_you_like_ivr_services?.length
              ? toTitleCase(ivr_would_you_like_ivr_services)
              : "-"
          }
        />
        <ReviewAttribute label="IVR Language" value={languageValue || "-"} />
        <ReviewAttribute
          label="What Dialing would you like to use with the IVR?"
          value={dialingValue}
        />

        <ReviewAttribute
          label="Would you like i2c to provide the toll-free number/DID?"
          value={
            ivr_would_you_like_i2c_to_provide_toll_free_number_did?.length
              ? toTitleCase(
                  ivr_would_you_like_i2c_to_provide_toll_free_number_did,
                )
              : "-"
          }
        />
        <ReviewAttribute
          label="Would you like to RESPORG your Toll Free number to i2c?"
          value={
            ivr_would_you_like_to_resporg_your_toll_free_number_to_i2c?.length
              ? toTitleCase(
                  ivr_would_you_like_to_resporg_your_toll_free_number_to_i2c,
                )
              : "-"
          }
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default IVRInteractiveVoiceResponseOverview;
